export default __webpack_public_path__ + "static/media/Logo.8f7c2adc.png";